import type { Messages } from './en.js';

// Slovenščina. Typed as Messages: a key missing here (or added here
// without existing in en.ts) fails the typecheck gate — see ADR-0032.
export const sl: Messages = {
  navAdmin: 'Skrbništvo',
  navTemplates: 'Predloge',
  navMenu: 'Meni',
  templatesNew: 'Nova predloga',
  templatesRepeat: 'Ponavljanje',
  templatesEmpty: 'Ni še predlog.',
  templatesMultiplier: 'Množitelj plačila',
  switchProfile: 'Zamenjaj profil',
  language: 'Jezik',
  close: 'Zapri',
  profileMenu: 'Tvoj profil in nastavitve',
  accessRequiredTitle: 'Potrebna je družinska povezava',
  accessRequiredBody: 'Na tem brskalniku odprite zasebno povezavo za pridružitev, ki jo dobite od skrbnika družine. Potem bo naprava ostala avtorizirana.',

  pickerWho: 'Kdo si?',
  pickerHi: 'Živjo, {name}',
  pickerEnterPin: 'Vnesi svoj PIN',
  pickerUnlock: 'Odkleni',
  pickerBack: 'Nazaj',
  pillAdmin: 'skrbnik',
  pickerSharedDisplay: 'Družinski zaslon',

  displayTitle: 'Naloge',
  displayDone: 'Opravljeno — izberi, kdo je to naredil',
  displayWhoTitle: 'Kdo je to naredil?',
  displayWhoDidIt: '{title} — kdo je to naredil?',
  displayWrongPin: 'Napačen PIN — poskusi znova',

  setupWelcome: 'Dobrodošli',
  setupIntro: 'Enkratna nastavitev. Vse ostane na tej napravi/strežniku — nič ne zapusti vašega doma.',
  setupFamilyLabel: 'Ime gospodinjstva',
  setupFamilyPlaceholder: 'npr. Novakovi',
  setupAdminLabel: 'Tvoje ime (postaneš prvi skrbnik)',
  setupAdminPlaceholder: 'Tvoje ime',
  setupPinLabel: 'Tvoj PIN',
  setupPinPlaceholder: 'Neobvezno, 4+ števke',
  setupCreate: 'Ustvari',
  setupHowStart: 'Kako želiš začeti?',
  setupBlankTitle: 'Vse bom uredil sam',
  setupBlankBlurb: 'Začni s praznim. Naloge, nagrade in pravila dodaš sam.',
  setupGuidedTitle: 'Vodi me skozi predloge',
  setupGuidedBlurb: 'Izberi tip gospodinjstva; pripravimo smiselne oznake, nagrade in pravila.',
  setupHousehold: 'Kakšno je vaše gospodinjstvo?',
  setupHouseholdSingle: 'Samo jaz',
  setupHouseholdSingleBlurb: 'Spremljaj svoje naloge, nagradi se sam.',
  setupHouseholdCouple: 'Par',
  setupHouseholdCoupleBlurb: 'Pravično uravnotežita, kdo naredi dovolj.',
  setupHouseholdFamily: 'Družina z otroki',
  setupHouseholdFamilyBlurb: 'Opravila, domače naloge, čas pred zaslonom, žepnina.',
  setupHouseholdShared: 'Skupno gospodinjstvo',
  setupHouseholdSharedBlurb: 'Sostanovalci in večni razpored čiščenja.',
  setupBackArrow: '← Nazaj',
  setupStep: 'Korak {current} od {total}',
  setupQJobTitle: 'Želiš spremljati plačano delo?',
  setupQJobBody:
    'Zabeležene delovne ure (recimo 8-urna izmena) štejejo kot zaseden čas. Pogled pravičnosti nato pričakuje manj opravil od nekoga, ki je pravkar prišel iz službe. Dodala bi se oznaka »služba« za beleženje zasedenega časa.',
  setupQJobYes: 'Da, spremljaj delo',
  setupQJobNo: 'Ne, preskoči',
  setupQSchoolTitle: 'Naj se štejejo tudi šolski dnevi?',
  setupQSchoolBody:
    'Šolske ure štejejo kot zaseden čas otrok — enaka ideja kot služba pri odraslih. Šolsko popoldne pomeni manj pričakovanih opravil tisti dan. Dodala bi se oznaka »šola«.',
  setupQSchoolYes: 'Da, spremljaj šolo',
  setupQSchoolNo: 'Ne, preskoči',
  setupQHomeworkTitle: 'So otroci že v letih domačih nalog?',
  setupQHomeworkBody:
    'Domače naloge bi prinašale vidne točke na osebni lestvici, a privzeto brez žepnine (to lahko kasneje spremeniš). Dodala bi se oznaka »domača naloga«.',
  setupQHomeworkYes: 'Da, dodaj domače naloge',
  setupQHomeworkNo: 'Ne, preskoči',
  setupQKidApprovalTitle: 'Naj otroška poraba potrebuje potrditev starša?',
  setupQKidApprovalBody:
    'Člani v skupini »otrok« bi zahteve za porabo pošiljali staršu v potrditev, namesto da porabijo neposredno. Kadar koli spremenljivo pod Skrbništvo → Dovoljenja.',
  setupQKidApprovalYes: 'Da, zahtevaj potrditev',
  setupQKidApprovalNo: 'Ne, porabljajo prosto',
  setupReview: 'Pregled',
  setupReviewIntro: 'Glede na tvoje odgovore bo ustvarjeno naslednje — nič še ni dodano:',
  setupReviewNothing: 'Nič — vse, kar si izbral, že obstaja.',
  setupReviewEditable: 'Vse ostane urejljivo pod Skrbništvom.',
  setupCreateThese: 'Ustvari to',
  setupPlanLabel: 'Oznaka »{name}«',
  setupPlanReward: 'Nagrada: {title} ({cost} min)',
  setupPlanRule: 'Pravilo: {rule}',
  setupAllSet: 'Pripravljeno!',
  setupCreatedForYou: 'Ustvarjeno zate (vse urejljivo v Skrbništvu):',
  setupNothingCreated: 'Vse je bilo že pripravljeno.',
  setupSummaryTag: 'Oznaka »{name}«',
  setupSummaryReward: 'Nagrada »{name}«',
  setupNext: 'Naprej',
  setupAddMembersTitle: 'Dodaš zdaj še družinske člane?',
  setupAddMembersBlurb:
    'Vsi, ki naj služijo in porabljajo. PIN-e, skrbniške pravice in skupine lahko kadar koli nastaviš v Skrbništvu.',
  setupMemberPlaceholder: 'npr. Ben',
  setupAddMemberBtn: 'Dodaj',
  setupMembersDone: 'Končano — gremo',
  setupMembersAdmin: 'Dodal jih bom v Skrbništvu',

  tasksTitle: 'Naloge',
  tasksEmpty: 'Nič za postoriti — uživaj v prostem času.',
  tasksWontDo: 'Ne bom naredil',
  tasksWontDoHint: 'Prekliči nalogo — samo skrbniki',
  tasksNotNeeded: 'Ni bilo treba',
  tasksNotNeededHint: 'Zapri brez plačila — danes pač ni bilo potrebno',
  tasksDone: 'Opravljeno',
  tasksMore: 'Več možnosti',
  tasksMoreHint: 'Več možnosti za to nalogo',
  tasksCompleteFor: 'Opravi za …',
  tasksDue: 'rok {date}',
  tasksAddTitle: 'Dodaj nalogo',
  tasksAddPlaceholder: 'npr. Zalij rože',
  composeNameLabel: 'Ime naloge',
  tasksAdd: 'Dodaj',
  tasksAdvanced: 'Napredno …',
  // Sestavljalnik nalog (ADR-0042)
  composeWorth: 'Vrednost',
  composeMinSuffix: 'min',
  composeMore: 'Več',
  composeLess: 'Manj',
  composeFromTemplate: 'Ustvari nalogo iz predloge',
  composeWhoCanDo: 'Kdo lahko opravi',
  composeVisibility: 'Prikaži',
  composeFollowupHeading: 'Naloge v nadaljevanju (nastanejo, ko je ta opravljena)',
  composeFollowupAfter: 'po',
  composeFollowupTemplate: 'Izberi predlogo …',
  composeFollowupAdd: '+ Dodaj nadaljevanje',
  composeFollowupRemove: 'Odstrani nadaljevanje',
  composeAddTask: 'Dodaj nalogo',
  composeSaveTemplate: 'Shrani kot predlogo',
  composeTemplateHint: '· uporabi jo pozneje brez urnika',

  builderTitle: 'Sestavi nalogo',
  builderAccess: 'Dostop',
  builderTiming: 'Prikaži samo med',
  builderRepeatNote:
    'Če naj se ponavlja, jo shrani kot predlogo — pogostost nastaviš pod Predloge.',
  eligEveryone: 'Vsi',
  eligType: 'Vpiši ime — otroci, Ana …',
  eligGroupTag: 'skupina',
  eligNoMatches: 'Ni zadetkov',
  eligRemove: 'Odstrani',
  tasksModalTitle: 'Nastavitve naloge',
  tasksModalName: 'Ime',
  tasksModalNamePlaceholder: 'Ime naloge',
  tasksModalMinutes: 'Minute (koliko plača)',
  tasksModalRepeats: 'Ponavljanje',
  tasksRepeatNone: 'se ne ponavlja',
  tasksRepeatDaily: 'vsak dan',
  tasksRepeatWeekly: 'vsak teden',
  tasksRepeatMonthly: 'vsak mesec',
  tasksEvery: 'vsakih',
  tasksUnitDays: 'dni',
  tasksUnitWeeks: 'tednov',
  tasksUnitMonths: 'mesecev',
  tasksModalDue: 'Rok (samo enkratne naloge)',
  tasksModalVisibility: 'Prikazano komu (za preglednost seznamov — ni skrivnost)',
  tasksVisibilityEveryone: 'vsem',
  tasksVisibilityAssignee: 'samo tistim, ki jih zadeva (po upravičenosti)',
  tasksVisibilityAdmins: 'samo skrbnikom',
  tasksModalLabels: 'Oznake',
  tasksNoLabels: 'še ni oznak',
  tasksModalEligibility: 'Kdo lahko to naredi (prazno = vsi)',
  tasksEligibilityMembers: 'Osebe',
  tasksEligibilityGroups: 'Skupine',
  tasksNoGroups: 'še ni skupin',
  tasksModalShowAt: 'Pokaži ob (skrito pred tem časom vsak dan)',
  tasksModalHideBy: 'Skrij do (po tem času označeno kot zamujeno, še vedno se lahko opravi)',
  tasksMissedLabel: 'Zamujeno',
  tasksCancel: 'Prekliči',
  tasksModalAdd: 'Dodaj nalogo',
  tasksNameMinutesRequired: 'Ime in minute so obvezni.',
  sentForApproval: 'Poslano staršu v potrditev.',
  tasksHistoryTitle: 'Nedavno zaključeno',
  statusDone: 'opravljeno',
  statusNotNeeded: 'ni bilo treba',
  statusExpired: 'poteklo',
  statusCancelled: 'preklicano',

  walletTitle: 'Denarnica',
  walletBalance: 'Razpoložljivo stanje',
  walletRewards: 'Nagrade',
  walletNoRewards: 'Nagrad še ni — skrbnik jih lahko doda.',
  walletBuy: 'Kupi',
  walletFreeformTitle: 'Porabi za kaj drugega',
  walletFreeformPlaceholder: 'Za kaj? npr. prost dan',
  walletSpend: 'Porabi',
  walletHistory: 'Zgodovina',

  boardTitle: 'Lestvica',
  boardWeek: 'Teden',
  boardMonth: 'Mesec',
  boardRaw: 'Skupaj',
  boardFairness: 'Pravičnost',
  boardRange: '{from} → {to} (izključno)',
  boardFamily: 'Družinska lestvica',
  boardNamed: 'Lestvica: {name}',
  boardFairnessHint: 'Prispevek glede na dejansko razpoložljiv čas (po službi/šoli).',

  todayTitle: 'Danes',
  todayEmpty: 'Danes ni ničesar na tabli.',
  todayCompleteOwn: 'Označi »{title}« kot opravljeno',
  todayActAs: 'Opravljaj naloge kot {name}',
  todayActAsTitle: 'Kdo si?',
  todayActingStop: 'Nehaj opravljati naloge kot {name}',
  todayActingAs: 'Naloge opravlja {name}',
  todayActingExit: 'Končaj',
  todayCompleteFor: 'Označi »{title}« kot opravljeno za {name}',

  policyActionLabel: 'Dejanje',
  policyTargetLabel: 'Velja za',
  policyValueLabel: 'Pravilo',
  adminMemberLabel: 'Član',
  adminTagKind: 'Vrsta',
  adminTagSpending: 'Poraba',
  adminRewardCost: 'Cena',
  adminCommittedDate: 'Datum',
  adminCommittedMinutes: 'Zaseden čas',
  adminAccessLinkLabel: 'Povezava za pridružitev',
  walletSpendAmount: 'Minute za porabo',
  walletSpendNote: 'Za kaj?',
  setupMemberNameLabel: 'Ime',
  adminSectionsLabel: 'Razdelki nastavitev',
  adminSectionPeople: 'Družina',
  adminSectionTasks: 'Naloge',
  adminSectionLedger: 'Obračun',
  adminSectionGeneral: 'Splošno',
  adminSettingsTitle: 'Nastavitve gospodinjstva',
  adminWeekStart: 'Začetek tedna na lestvici',
  adminWakingHours: 'Budne ure na dan (pogled pravičnosti)',
  adminSave: 'Shrani',
  adminSaved: 'Shranjeno.',
  weekdayMonday: 'ponedeljek',
  weekdayTuesday: 'torek',
  weekdayWednesday: 'sreda',
  weekdayThursday: 'četrtek',
  weekdayFriday: 'petek',
  weekdaySaturday: 'sobota',
  weekdaySunday: 'nedelja',
  actionCreateAdhoc: 'Dodajanje naloge',
  actionCreateRecurring: 'Dodajanje ponavljajoče se naloge',
  actionSpendFreeform: 'Poraba (poljubna)',
  actionSpendCatalog: 'Nakup nagrade',
  actionCommittedLog: 'Beleženje zasedenega časa',
  approvalAddTask: '{name}: dodaj nalogo »{title}« ({minutes} min)',
  approvalAddRecurring: '{name}: dodaj ponavljajočo se nalogo »{title}« ({minutes} min, {freq})',
  approvalSpend: '{name}: porabi {minutes} min — {note}',
  approvalBuyReward: '{name}: kupi nagrado #{id}',
  approvalCommitted: '{name}: zabeleži {minutes} min zasedenosti dne {date}',
  approvalFallback: '{name}: {action}',
  adminApprovalsTitle: 'Čaka na potrditev',
  adminApprove: 'Potrdi',
  adminDeny: 'Zavrni',
  adminPermissionsTitle: 'Dovoljenja',
  adminPermissionsHint:
    'Kdo sme kaj. Najbolj specifično pravilo zmaga: oseba pred skupino (oznako), skupina pred vsemi. Skrbniki smejo vedno.',
  policyAllowed: 'dovoljeno',
  policyApproval: 'potrebuje potrditev',
  policyDenied: 'prepovedano',
  adminEveryone: 'Vsi',
  adminGroup: 'Skupina: {name}',
  adminMember: 'Član: {name}',
  adminNoRules: 'Ni pravil — vsem je vse dovoljeno.',
  adminRemove: 'Odstrani',
  adminSetRule: 'Nastavi pravilo',
  adminMembersTitle: 'Člani',
  adminMakeAdmin: 'Povišaj v skrbnika',
  adminDemote: 'Odvzemi skrbništvo',
  adminClearPin: 'Počisti PIN',
  adminNamePlaceholder: 'Ime',
  adminAvatarPlaceholder: 'ikona (neobvezno)',
  adminAddMember: 'Dodaj člana',
  adminOneTime: 'enkratno',
  adminRetire: 'Umakni',
  adminEdit: 'Uredi',
  freqDaily: 'dnevno',
  freqWeekly: 'tedensko',
  freqMonthly: 'mesečno',
  adminAdd: 'Dodaj',
  // Opozorila o osirotelih nalogah (ADR-0043)
  adminOrphansTitle: 'Naloge, ki jih nihče ne more opraviti',
  adminOrphansIntro:
    'Te ponavljajoče se naloge so dodeljene samo neaktivnim ali odstranjenim članom, zato ne pridejo na noben seznam. Dodelite jih znova (uredite, kdo jih lahko opravi) ali jih umaknite.',
  adminOrphanReason: 'Noben aktiven član je ne more opraviti',
  deactivateOrphanWarning:
    'Če deaktivirate člana {name}, teh nalog ne bo mogel opraviti nihče: {titles}. Najprej jih dodelite znova ali vseeno deaktivirajte.',
  deactivateAnyway: 'Vseeno deaktiviraj',
  adminRewardsTitle: 'Nagrade',
  adminRewardPlaceholder: 'npr. 30 min zaslona',
  adminTagsTitle: 'Oznake',
  tagNotSpendable: 'ni porabljivo',
  tagBoard: 'lestvica: {name}',
  tagKindCategory: 'kategorija',
  tagKindEligibility: 'upravičenost',
  tagSpendable: 'porabljivo',
  adminTagPlaceholder: 'npr. šola',
  adminTagBoardPlaceholder: 'svoja lestvica? (neobvezno)',
  adminTagsHint:
    'Oznake kategorij razvrščajo naloge (veljajo pravila). Oznake upravičenosti določajo, kdo sme opraviti nalogo — članom jih za zdaj dodeli prek API-ja.',
  adminFixTitle: 'Popravi napako',
  adminFixHint:
    'Naloga v resnici ni bila opravljena? Razveljavi zaslužek. Poraba je bila napačna? Razveljavi jo — minute se vrnejo. Zgodovina v vsakem primeru ostane.',
  adminNothingToCorrect: 'Zaenkrat ni česa popraviti.',
  adminEntryNumber: 'vnos #{id}',
  adminReversedNote: 'razveljavil skrbnik',
  adminRefundedNote: 'vrnil skrbnik',
  adminReverse: 'Razveljavi',
  adminUndoSpend: 'Razveljavi porabo',
  adminCommittedTitle: 'Zabeleži zaseden čas (služba/šola)',
  adminCommittedHint: 'Hrani pogled pravičnosti: od zasedenih se pričakuje manj.',
  adminCommittedPlaceholder: 'služba / šola …',
  adminLog: 'Zabeleži',
  adminAccessTitle: 'Družinska povezava',
  adminAccessDisabled: 'Javna povezava za pridružitev ni aktivna. Aplikacija se obnaša kot lokalni zaupanja vreden strežnik.',
  adminAccessEnabled: 'Povezava za pridružitev je aktivna. Brskalniki, ki jo odprejo, ostanejo avtorizirani {days} dni, rok pa se ob uporabi aplikacije podaljšuje.',
  adminAccessCreate: 'Ustvari povezavo',
  adminAccessRotate: 'Zamenjaj povezavo',
  adminAccessDisable: 'Onemogoči povezavo',
  adminAccessLinkReady: 'To povezavo kopirajte zdaj; prikazana je samo po ustvarjanju ali zamenjavi.',
  adminCopy: 'Kopiraj',
  adminCopied: 'Kopirano.',
  adminAccessCopyFallback: 'Povezava je označena.',
};
